import React from "react";
import styled from "styled-components";
import { CheckCircle, ArrowRight, Calendar } from "lucide-react";
import { useNavigate } from "react-router-dom";

/* ================= STYLES ================= */

const Page = styled.div`
  min-height: 100vh;
  background: radial-gradient(
      800px at 50% 0%,
      rgba(99, 102, 241, 0.18),
      transparent 60%
    ),
    ${({ theme }) => theme.colors.bg};

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

const Card = styled.div`
  max-width: 520px;
  width: 100%;
  background: ${({ theme }) => theme.colors.cardBg};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 28px;
  padding: 44px;
  text-align: center;
  box-shadow: ${({ theme }) => theme.shadows.card};
`;

const IconWrap = styled.div`
  width: 88px;
  height: 88px;
  margin: auto;
  border-radius: 50%;
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.25),
    rgba(34, 197, 94, 0.05)
  );
  display: grid;
  place-items: center;
`;

const Title = styled.h1`
  margin-top: 24px;
  font-size: 28px;
  font-weight: 1000;
`;

const Sub = styled.p`
  margin-top: 12px;
  font-size: 16px;
  opacity: 0.75;
  line-height: 1.6;
`;

const Info = styled.div`
  margin-top: 28px;
  padding: 18px;
  border-radius: 16px;
  background: rgba(99, 102, 241, 0.08);
  border: 1px solid rgba(99, 102, 241, 0.25);
  font-size: 14px;
  line-height: 1.6;
`;

const Actions = styled.div`
  margin-top: 32px;
  display: grid;
  gap: 14px;
`;

const PrimaryBtn = styled.button`
  height: 52px;
  border-radius: 999px;
  border: none;
  font-weight: 900;
  cursor: pointer;
  color: #fff;

  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.primary},
    ${({ theme }) => theme.colors.accent}
  );

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 12px 32px rgba(99, 102, 241, 0.45);
  }
`;

const SecondaryBtn = styled.button`
  height: 48px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: transparent;
  color: ${({ theme }) => theme.colors.text};
  font-weight: 800;
  cursor: pointer;
`;

/* ================= COMPONENT ================= */

export default function GoogleCalendarSuccess() {
  const navigate = useNavigate();

  return (
    <Page>
      <Card>
        <IconWrap>
          <CheckCircle size={42} color="#22c55e" />
        </IconWrap>

        <Title>Calendar Connected 🎉</Title>

        <Sub>
          Your daily learning reminders are now synced with your
          <strong> Google Calendar</strong>.
        </Sub>

        <Info>
          <Calendar size={14} /> You’ll receive:
          <br />
          • Daily calendar notifications <br />
          • Automatic reminders to stay consistent
          <br />
          <br />
          You can manage or disconnect this anytime from your profile.
        </Info>

        <Actions>
          <PrimaryBtn onClick={() => navigate("/my-roadmap")}>
            Start Today’s Learning <ArrowRight size={16} />
          </PrimaryBtn>

          <SecondaryBtn onClick={() => navigate("/dashboard")}>
            Go to Dashboard
          </SecondaryBtn>
        </Actions>
      </Card>
    </Page>
  );
}
